import React from "react";
import SwaggerUI from "swagger-ui-react";
import {AppLayout} from "../AppLayout";
import {API_V1_SWAGGER_SPEC} from "../../utils/apiSwaggerUtils";
import "swagger-ui-react/swagger-ui.css";

export const ApiV1SwaggerPage: React.FC = () => (
    <AppLayout>
        <SwaggerUI spec={API_V1_SWAGGER_SPEC} i18nIsDynamicList />
    </AppLayout>
);
